interface ClientEnv {
  supabaseUrl: string;
  supabaseAnonKey: string;
  appName: string;
  defaultLocale: string;
  supportEmail: string;
}

function required(key: string, value: string | undefined): string {
  if (!value) throw new Error(`Missing required env var ${key}`);
  return value;
}

export const env: ClientEnv = {
  supabaseUrl: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY),
  appName: import.meta.env.VITE_APP_NAME ?? 'MoniGo',
  defaultLocale: import.meta.env.VITE_DEFAULT_LOCALE ?? 'fr',
  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL ?? 'support@monigo.example',
};
